import { render, staticRenderFns } from "./DbcdEx_Export.vue?vue&type=template&id=2e23ba6c"
import script from "./DbcdEx_Export.vue?vue&type=script&lang=js"
export * from "./DbcdEx_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports